import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FaBars, 
  FaTimes, 
  FaPhone, 
  FaWhatsapp, 
  FaEnvelope,
  FaChevronDown,
  FaUserCheck,
  FaGraduationCap,
  FaHome,
  FaPassport,
  FaCreditCard,
  FaArrowRight
} from 'react-icons/fa';
import './Header.css';
import btgLogo from '../../assets/images/Logo-BTG-3-removebg-preview.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const handleNavigation = (path) => {
    setIsMenuOpen(false);
    if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(path);
    }
  };

  const handleCtaClick = () => {
    navigate('/contact');
  };

  const services = [
    {
      icon: <FaGraduationCap />,
      title: 'Admission',
      description: 'Dans les écoles françaises',
      link: '#btg-services'
    },
    {
      icon: <FaHome />,
      title: 'Logement',
      description: 'Étudiant en France',
      link: '#btg-services'
    },
    {
      icon: <FaPassport />,
      title: 'Visa',
      description: 'Étudiant',
      link: '#btg-services'
    },
    {
      icon: <FaCreditCard />,
      title: 'AVI',
      description: 'Attestation de Virement Irrévocable',
      link: '#btg-services'
    }
  ];

  const navItems = [
    { name: 'Accueil', link: '/' },
    { 
      name: 'Services', 
      link: '#btg-services',
      dropdown: services
    },
    { name: 'Témoignages', link: '#btg-temoignages' },
    { name: 'FAQ', link: '#btg-faq' },
    { name: 'Contact', link: '/contact' }
  ];

  return (
    <>
      <header className={`btg-header ${isScrolled ? 'btg-scrolled' : ''}`}>
        <div className="btg-container">
          <nav className="btg-nav">
            {/* Logo - sans texte */}
            <Link to="/" className="btg-logo">
              <img 
                src={btgLogo} 
                alt="BTG CONSEIL" 
                className="btg-logo-image"
              />
            </Link>

            {/* Desktop Navigation */}
            <ul className="btg-nav-menu">
              {navItems.map((item, index) => (
                <li 
                  key={index} 
                  className="btg-nav-item"
                  onMouseEnter={() => item.dropdown && toggleDropdown(item.name)}
                  onMouseLeave={() => item.dropdown && toggleDropdown(null)}
                >
                  {item.dropdown ? (
                    <button className="btg-nav-link">
                      {item.name}
                      <FaChevronDown className="btg-dropdown-arrow" />
                    </button>
                  ) : (
                    <Link 
                      to={item.link} 
                      className="btg-nav-link"
                      onClick={() => handleNavigation(item.link)}
                    >
                      {item.name}
                    </Link>
                  )}

                  {item.dropdown && activeDropdown === item.name && (
                    <div className="btg-dropdown-menu">
                      <div className="btg-dropdown-content">
                        {item.dropdown.map((service, serviceIndex) => (
                          <a 
                            key={serviceIndex} 
                            href={service.link}
                            className="btg-dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              handleNavigation(service.link);
                            }}
                          >
                            <div className="btg-dropdown-icon">
                              {service.icon}
                            </div>
                            <div className="btg-dropdown-text">
                              <div className="btg-dropdown-title">
                                {service.title}
                              </div>
                              <div className="btg-dropdown-desc">
                                {service.description}
                              </div>
                            </div>
                            <FaArrowRight className="btg-dropdown-arrow-icon" />
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>

            {/* CTA Button */}
            <div className="btg-header-actions">
              <button className="btg-main-cta-btn" onClick={handleCtaClick}>
                <FaUserCheck />
                Demander un Devis
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="btg-mobile-toggle"
              onClick={toggleMenu}
            >
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </nav>
        </div>

        {/* Mobile Menu */}
        <div className={`btg-mobile-menu ${isMenuOpen ? 'btg-active' : ''}`}>
          <div className="btg-mobile-menu-content">
            {navItems.map((item, index) => (
              <div key={index} className="btg-mobile-nav-item">
                {item.dropdown ? (
                  <>
                    <div className="btg-mobile-nav-link-header">
                      <span className="btg-mobile-nav-link">{item.name}</span>
                    </div>
                    <div className="btg-mobile-dropdown">
                      {item.dropdown.map((service, serviceIndex) => (
                        <a 
                          key={serviceIndex} 
                          href={service.link}
                          className="btg-mobile-dropdown-item"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigation(service.link);
                          }}
                        >
                          <div className="btg-mobile-dropdown-icon">
                            {service.icon}
                          </div>
                          <span>{service.title}</span>
                        </a>
                      ))}
                    </div>
                  </>
                ) : (
                  <Link 
                    to={item.link}
                    className="btg-mobile-nav-link"
                    onClick={() => handleNavigation(item.link)}
                  >
                    {item.name}
                  </Link>
                )}
              </div>
            ))}
            
            <div className="btg-mobile-contact">
              <a href="tel:+33763705088" className="btg-mobile-contact-link">
                <FaPhone />
                <span>+33 7 63 70 50 88</span>
              </a>
              <a href="https://wa.me/33763705088" className="btg-mobile-contact-link">
                <FaWhatsapp />
                <span>WhatsApp</span>
              </a>
              <a href="mailto:contact@btgconseil.com" className="btg-mobile-contact-link">
                <FaEnvelope />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;